<template><div><h1 id="versandkosten" tabindex="-1"><a class="header-anchor" href="#versandkosten"><span>Versandkosten</span></a></h1>
<p>Versandkosten — Definiert Preise von Portoartikeln</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>&gt;Dient dem automatischen Vorschlag der Versandkosten im Auftrag. Je nach definiertem Verarbeitungscode im Auftrag kann ein bestimmter Betrag festgelegt werden. Damit der Vorschlag erscheint, muss der Schalter Porto in der <RouteLink to="/referenz/refs/ft.refdata.tblaufart.html" title="Auftragsart">Auftragsart</RouteLink> auf ja stehen.</p>
<p>Die Versandkosten werden auch in einer Position als Portoartikel erfasst. Der Artikel muss in der Auftragsart und in dieser Tabelle übereinstimmen.</p>
<p>Pfad: <code v-pre>Verkauf → Tabellen → Versandkosten</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>VerarbCode</dt>
<dd><a class="link" href="ft.refdata.tblverarb.html" title="Verarbeitungsarten">Verarbeitungscode</a>.</dd>
<dt>Artikelnummer</dt>
<dd>Bezeichnet den Portoartikel, der erfasst wird.</dd>
<dt>Versandkost</dt>
<dd>Versandkosten in Franken.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


